import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInboxEmpty: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconInboxEmpty"><Path fillRule="evenodd" clipRule="evenodd" d="M5.41968 4H18.5803L23 11.7344V20H1V11.7344L5.41968 4ZM8 13H3V18H21V13H16L14.5 15H9.5L8 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInboxEmpty;
